<template>
    <div class="animated fade-in">
        <c-data-table
            class="my-4"
            :items="filteredItems"
            :fields="fields"
            :table-filter="true"
            :items-per-page="params.limit"
            items-per-page-select
            hover
            sorter
            :pagination="false"
            :sorterValue="params.sort"
            :tableFilterValue="params.filter"
            :loading="loading"
            @pagination-change="pageChange"
            @update:sorter-value="sortChange"
            @update:table-filter-value="filterChange">
            <template #number="{item}">
              <td>
                  <router-link v-if="item.number" class="font-weight-bold" :to="'/orders/'+item.id">{{ item.number }}</router-link>
              </td>
            </template>
            <template #po_number="{item}">
                <td>
                    <router-link v-if="item.po_number" class="font-weight-bold" :to="'/orders/'+item.id">{{ item.po_number }}</router-link>
                </td>
            </template>
            <template #created_at="{item}">
                <td>
                    <span v-if="getFirstStatus(item)">{{ getFirstStatus(item).created_at | moment("MMM D, YYYY") }}</span>
                </td>
            </template>
            <template #estimated_date="{item}">
                <td>
                    <span v-if="item.estimated_date">{{ item.estimated_date | moment("MMM D, YYYY") }}</span>
                </td>
            </template>
            <template #customer_location.address="{item}">
                <td>
                    <div v-for="(order_location) in item.order_locations">
                        {{ (order_location.location ? 'Drop '+order_location.drop+' - ' +cleanString(order_location.location.address) : null) }}
                    </div>
                </td>
            </template>
            <template #count="{item}">
                <td>
                    {{ countItems(item) }}
                </td>
            </template>
            <template #fill="{item}">
                <td>
                    {{ (item.fill ? 'Yes' : 'No') }}
                </td>
            </template>
            <template #transport="{item}">
                <td>
                    {{ (item.pickup ? 'Pickup' : (item.delivery ? 'Delivery' : 'TBD')) }}
                </td>
            </template>
            <template #status="{item}">
                <td>
                    <div v-if="getLastStatus(item)">
                        <c-badge :color="getColor(getLastStatus(item).order_status.name)">{{getLastStatus(item).order_status.name}}</c-badge>
                    </div>
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <b-button size="sm" class="p-0 m-0 px-2" :to="'/orders/'+item.id+'/edit'">
                      <!-- <i class="fal fa-pencil"></i> -->
                      Send Edit Request
                    </b-button>
                </td>
            </template>
        </c-data-table>
        <c-pagination
            :active-page="params.page"
                :pages="Math.ceil(+(total/params.limit))"
            @update:activePage="updatePageNum"
        ></c-pagination>
    </div>
</template>

<script>
  import OrderContact from "../../models/OrderContact";
  import OrderLocation from "../../models/OrderLocation";
  import OrderItem from "../../models/OrderItem";
  import Order from "../../models/Order";
  import OrderStatusLog from "../../models/OrderStatusLog";
  import {FETCH_ENTITY, GREEDY_FETCH_ENTITY} from "@/store/action-types";

  import FetchPriceLists from "@/components/shared/mixins/FetchPriceLists";

  export default {
      name: 'OrderTable',
      components: {},
      mixins: [FetchPriceLists],
      props: ['current', 'closed'],
      data () {
        return {
          loading: true,
          orders: [],
          items: [],
          fields: [
            { key: 'status', label: 'Status', sorter: false },
            { key: 'created_at', label: 'Created' },
            { key: 'number', label: 'Order #' },
            { key: 'po_number', label: 'PO #' },
            { key: 'estimated_date', label: 'Requested/Scheduled' },
            { key: 'customer_location.address', label: 'Address', sorter: false },
            { key: 'count', label: 'Count', sorter: false },
            { key: 'fill', label: 'Fill?', sorter: false },
            { key: 'transport', label: 'Transport', sorter: false },
            { key: 'actions', label: 'Actions', sorter: false },
          ],
          total: null,
          params: {
            page: 1,
            limit: 20,
            sort: { column: 'created_at', asc : false},
            filter: null
          },
        }
      },
      computed: {
        filteredItems() {
          return this.items.filter(item => {
            if (this.current) {
              return this.getLastStatus(item).order_status.name !== 'Closed'
            }
            
            if (this.closed) {
              return this.getLastStatus(item).order_status.name === 'Closed'
            }
            
            return this.items
          })
        }
      },
	  methods: {
      calculateOrderTotal() {},
          countItems: function(order) {
            let count = 0;
            order.order_items.forEach((item) => {
                count = count + +(item.quantity);
            });
            return count;
          },
        rowClick: function(item, index) {
            if(item.id) {
                this.$router.push('/orders/'+item.id);
            }
          },
        getFirstStatus(order) {
          let logs = order.order_status_logs;
          return (logs && logs.length ? logs[0] : null);
        },
        getLastStatus(order) {
          let logs = order.order_status_logs;
          return (logs && logs.length ? logs[logs.length-1] : null);
        },
        getColor(status) {
            switch(status) {
              case 'Pending': return 'warning';
              case 'Cancelled': return 'danger';
              case 'Processed': return 'info';
              case 'Scheduled': return 'info';
              case 'Partially Completed': return 'info';
              case 'Completed': return 'success';
              case 'Shipped': return 'success';
              case 'Closed': return 'success';
            }
        },
        cleanString: function (html) {
          let txt = document.createElement('textarea');
          txt.innerHTML = html;
          return decodeURI(unescape(txt.value));
        },
        pageChange: function(val) {
          this.params.limit = val;
          this.fetchOrders();
        },
        sortChange: function(val) {
          this.params.sort.column = val.column;
          this.params.sort.asc = val.asc;
          this.fetchOrders();
        },
        filterChange: function(val) {
          this.params.filter = (val ? (val != '' ? val : null) : null);
          this.fetchOrders();
        },
        updatePageNum: function(val) {
          this.params.page = val;
          this.fetchOrders();
        },
        fetchOrders: function() {
          this.loading = true;
          let params = JSON.parse(JSON.stringify(this.params));
          if(params && params.filter) {
            params.number = params.filter;
          }
          if(this.current) {
            params.current = true;
          }
          if(this.closed) {
            params.closed = true;
          }
          //Order.api().fetch(params)
          this.$store.dispatch(FETCH_ENTITY, {model: Order, params}).then((results) => {
            this.total = results.pagination.total || 0;
            if(!this.total) {
              this.orders = [];
              this.items = [];
              this.loading = false;
              return;
            }
            let order_ids = results.entities.orders.map((order) => order.id);
            /*let query = Order.query();
            if(params.number) {
              query.where('number', params.number);
            }
            if(params.current_status) {
              query.whereHas('order_status_logs', (q) => {
                q.where('user_id', 1);
              });
            }*/
            /*
            page: 1,
            limit: 20,
            sort: { column: 'created_at', asc : false},
            filter: null
             */

            Promise.all([
              this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: OrderContact, params: {order_id: order_ids.join('|')}}),
              this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: OrderLocation, params: {order_id: order_ids.join('|')}}),
              this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: OrderItem, params: {order_id: order_ids.join('|')}}),
              this.$store.dispatch(GREEDY_FETCH_ENTITY, {model: OrderStatusLog, params: {order_id: order_ids.join('|')}})
              /*OrderContact.api().fetch({order_id: identifiers.join('|'), limit: 999}),
              OrderLocation.api().fetch({order_id: identifiers.join('|'), limit: 999}),
              OrderItem.api().fetch({order_id: identifiers.join('|'), limit: 999}),
              OrderStatusLog.api().fetch({order_id: identifiers.join('|'), limit: 999}),*/
            ]).then((/*inner_results*/) => {
              let orders = Order.query().whereIdIn(order_ids).with([
                'order_contacts.contact',
                'order_locations.location',
                'order_items',
                'order_status_logs.order_status'
              ]).get();
              this.orders = orders;
              this.items = orders;
              this.loading = false;
              /*let contacts = inner_results[0].entities.order_contacts;
              contacts = contacts ? contacts : [];
              let locations = inner_results[1].entities.order_locations;
              locations = locations ? locations : [];
              let logs = inner_results[3].entities.order_status_logs;
              logs = logs ? logs : [];
              let contact_identifiers = [];
              let location_identifiers = [];
              let status_identifiers = [];
              contacts.forEach((contact) => {
                contact_identifiers.push(contact.contact_id);
              });
              locations.forEach((location) => {
                location_identifiers.push(location.location_id);
              });
              logs.forEach((log) => {
                status_identifiers.push(log.order_status_id);
              });
              Promise.all([
                Contact.api().fetch({id: contact_identifiers.join('|'), limit: 999}),
                Location.api().fetch({id: location_identifiers.join('|'), limit: 999}),
                OrderStatus.api().fetch({id: status_identifiers.join('|'), limit: 999}),
              ]).then(() => {
                let orders = [];
                this.orders.forEach((order) => {
                  orders.push(Order.query().where('id', order.id).with([
                    'order_contacts.contact',
                    'order_locations.location',
                    'order_items',
                    'order_status_logs.order_status'
                  ]).first());
                });
                this.orders = orders;
                this.items = orders;
                this.loading = false;
              });*/
            });
          });
        },
        chunk(arr, n) {
            return arr.slice(0,(arr.length+n-1)/n|0).
            map(function(c,i) { return arr.slice(n*i,n*i+n); });
        }
      },
      created() {
        this.fetchOrders();
      }
	}
</script>
